import script from "./EmployerFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployerFormPage.vue?vue&type=script&setup=true&lang=js"

import "./EmployerFormPage.vue?vue&type=style&index=0&id=9a319464&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a319464"]])

export default __exports__